import React, { Component } from "react";

import { connect } from "react-redux";

import { sdg1671cActions } from "../../../../../../_actions";
import { TextInput } from "carbon-components-react";


class RowRenderer extends Component {
  constructor(props) {
    super(props);

    this.handleTableChange = this.handleTableChange.bind(this);
    this.getProportionsColumns = this.getProportionsColumns.bind(this);
    this.getProportionsOfYoung = this.getProportionsOfYoung.bind(this);
    this.canCalculateProportion = this.canCalculateProportion.bind(this);
    this.canCalculateYouthProportion = this.canCalculateYouthProportion.bind(this);
    this.getProportionValue = this.getProportionValue.bind(this);
    this.getYouthProportionValue = this.getYouthProportionValue.bind(this);
  }

  handleTableChange(e) {
    this.props.handleTableChange(e.target.name, e.target.value);
  }

  // ─── Can-calculate helpers ─────────────────────────────────────────────────

  canCalculateProportion(index, name) {
    if (!this.props.data || !this.props.data.data || !this.props.data.data[index]) {
      return false;
    }
    const male = this.props.data.data[index]["male"]
      ? parseInt(this.props.data.data[index]["male"])
      : 0;
    const female = this.props.data.data[index]["female"]
      ? parseInt(this.props.data.data[index]["female"])
      : 0;
    return (male + female) > 0 && this.props.data.data[index][name] != null;
  }

  canCalculateYouthProportion(index) {
    if (!this.props.data || !this.props.data.data || !this.props.data.data[index]) {
      return false;
    }
    const male = this.props.data.data[index]["male"]
      ? parseInt(this.props.data.data[index]["male"])
      : 0;
    const female = this.props.data.data[index]["female"]
      ? parseInt(this.props.data.data[index]["female"])
      : 0;
    const age_under_35 = this.props.data.data[index]["age_under_35"]
      ? parseInt(this.props.data.data[index]["age_under_35"])
      : 0;
    const between_35_44 = this.props.data.data[index]["between_35_44"]
      ? parseInt(this.props.data.data[index]["between_35_44"])
      : 0;
    return (male + female) > 0 && (age_under_35 + between_35_44) > 0;
  }

  // ─── Raw calculation (sync to Redux when canCalculate is true) ─────────────

  getProportionsColumns(index, name) {
    const male = this.props.data.data[index]["male"]
      ? parseInt(this.props.data.data[index]["male"])
      : 0;
    const female = this.props.data.data[index]["female"]
      ? parseInt(this.props.data.data[index]["female"])
      : 0;

    if (
      (male > 0 || female > 0) &&
      this.props.data &&
      this.props.data.proportions &&
      this.props.data.proportions.length > 0 &&
      this.props.data.data[index][name] &&
      (this.props.data.proportions[index][name] === null ||
        parseFloat(this.props.data.proportions[index][name]).toFixed(2) !==
          parseFloat((this.props.data.data[index][name] / (female + male)) * 100.0).toFixed(2))
    ) {
      this.props.updateProportionsField(
        index,
        name,
        ((this.props.data.data[index][name] / (female + male)) * 100.0).toFixed(2)
      );
    } else {
      if (
        this.props.data &&
        this.props.data.data[index][name] === null &&
        this.props.data.proportions.length > 0 &&
        this.props.data.proportions[index][name]
      ) {
        this.props.updateProportionsField(index, name, null);
      }
    }

    return female + male > 0 && this.props.data.data[index][name]
      ? ((this.props.data.data[index][name] / (female + male)) * 100.0).toFixed(2)
      : "";
  }

  getProportionsOfYoung(index) {
    if (this.props.data && this.props.data.data && this.props.data.data[index]) {
      const male = this.props.data.data[index]["male"]
        ? parseInt(this.props.data.data[index]["male"])
        : 0;
      const female = this.props.data.data[index]["female"]
        ? parseInt(this.props.data.data[index]["female"])
        : 0;
      const age_under_35 = this.props.data.data[index]["age_under_35"]
        ? parseInt(this.props.data.data[index]["age_under_35"])
        : 0;
      const between_35_44 = this.props.data.data[index]["between_35_44"]
        ? parseInt(this.props.data.data[index]["between_35_44"])
        : 0;

      if (
        this.props.data.proportions &&
        this.props.data.proportions.length > 0 &&
        (this.props.data.data[index]["between_35_44"] || this.props.data.data[index]["age_under_35"]) &&
        male + female > 0 &&
        parseFloat(this.props.data.proportions[index]["age_under_44"]).toFixed(2) !==
          parseFloat(((age_under_35 + between_35_44) / (female + male)) * 100.0).toFixed(2)
      ) {
        this.props.updateProportionsField(
          index,
          "age_under_44",
          (((age_under_35 + between_35_44) / (male + female)) * 100).toFixed(2)
        );
      }

      return (this.props.data.data[index]["between_35_44"] || this.props.data.data[index]["age_under_35"]) &&
        male + female > 0
        ? (((age_under_35 + between_35_44) / (male + female)) * 100).toFixed(2)
        : "";
    }
  }

  // ─── Unified value getters ─────────────────────────────────────────────────

  /**
   * Returns the display value for a proportion cell.
   * - canCalculate → calculated value (also syncs to Redux)
   * - OGC actively editing → in-progress local value
   * - Otherwise → stored proportions value or "0.00"
   */
  getProportionValue(index, name, fieldSuffix) {
    const isOGC = this.props.user && this.props.user.user_type === "OGC";
    const canCalculate = this.canCalculateProportion(index, name);

    if (canCalculate) {
      return this.getProportionsColumns(index, name);
    }

    if (isOGC && this.props.editingFields) {
      const editingKey = `${this.props.index}:proportion:${name}:${fieldSuffix}`;
      if (this.props.editingFields[editingKey] !== undefined) {
        return this.props.editingFields[editingKey];
      }
    }

    if (
      this.props.data &&
      this.props.data.proportions &&
      this.props.data.proportions[index]
    ) {
      const stored = this.props.data.proportions[index][name];
      if (stored === null || stored === undefined || stored === 0) {
        return "0.00";
      }
      return parseFloat(stored).toFixed(2);
    }

    return "0.00";
  }

  getYouthProportionValue(index, fieldSuffix) {
    const isOGC = this.props.user && this.props.user.user_type === "OGC";
    const canCalculate = this.canCalculateYouthProportion(index);

    if (canCalculate) {
      return this.getProportionsOfYoung(index);
    }

    if (isOGC && this.props.editingFields) {
      const editingKey = `${this.props.index}:proportion:young:${fieldSuffix}`;
      if (this.props.editingFields[editingKey] !== undefined) {
        return this.props.editingFields[editingKey];
      }
    }

    if (
      this.props.data &&
      this.props.data.proportions &&
      this.props.data.proportions[index]
    ) {
      const stored = this.props.data.proportions[index]["age_under_44"];
      if (stored === null || stored === undefined || stored === 0) {
        return "0.00";
      }
      return parseFloat(stored).toFixed(2);
    }

    return "0.00";
  }

  render() {
    const isOGC = this.props.user && this.props.user.user_type === "OGC";

    return (
      <React.Fragment>
        <tr>
          <td style={{background: this.props.title.indexOf("Total") !== -1 ? "#FFC000" : "white"}}>
            {this.props.title}
          </td>
          <td>
            <TextInput
              id={`${this.props.index}:proportion:female:judges`}
              name={`${this.props.index}:proportion:female:judges`}
              labelText=""
              onChange={this.props.onProportionChange}
              onFocus={this.props.onProportionFocus}
              onBlur={this.props.onProportionBlur}
              value={this.getProportionValue(this.props.index, "female", "judges")}
              disabled={!isOGC || this.canCalculateProportion(this.props.index, "female")}
            />
          </td>
          <td>
            <TextInput
              id={`${this.props.index}:proportion:female:registrars`}
              name={`${this.props.index}:proportion:female:registrars`}
              labelText=""
              onChange={this.props.onProportionChange}
              onFocus={this.props.onProportionFocus}
              onBlur={this.props.onProportionBlur}
              value={this.getProportionValue(this.props.index + 4, "female", "registrars")}
              disabled={!isOGC || this.canCalculateProportion(this.props.index + 4, "female")}
            />
          </td>
          <td>
            <TextInput
              id={`${this.props.index}:proportion:young:judges`}
              name={`${this.props.index}:proportion:young:judges`}
              labelText=""
              onChange={this.props.onProportionChange}
              onFocus={this.props.onProportionFocus}
              onBlur={this.props.onProportionBlur}
              value={this.getYouthProportionValue(this.props.index, "judges")}
              disabled={!isOGC || this.canCalculateYouthProportion(this.props.index)}
            />
          </td>
          <td>
            <TextInput
              id={`${this.props.index}:proportion:young:registrars`}
              name={`${this.props.index}:proportion:young:registrars`}
              labelText=""
              onChange={this.props.onProportionChange}
              onFocus={this.props.onProportionFocus}
              onBlur={this.props.onProportionBlur}
              value={this.getYouthProportionValue(this.props.index + 4, "registrars")}
              disabled={!isOGC || this.canCalculateYouthProportion(this.props.index + 4)}
            />
          </td>
          <td>
            <TextInput
              id={`${this.props.index}:proportion:disabled:judges`}
              name={`${this.props.index}:proportion:disabled:judges`}
              labelText=""
              onChange={this.props.onProportionChange}
              onFocus={this.props.onProportionFocus}
              onBlur={this.props.onProportionBlur}
              value={this.getProportionValue(this.props.index, "disabled", "judges")}
              disabled={!isOGC || this.canCalculateProportion(this.props.index, "disabled")}
            />
          </td>
          <td>
            <TextInput
              id={`${this.props.index}:proportion:disabled:registrars`}
              name={`${this.props.index}:proportion:disabled:registrars`}
              labelText=""
              onChange={this.props.onProportionChange}
              onFocus={this.props.onProportionFocus}
              onBlur={this.props.onProportionBlur}
              value={this.getProportionValue(this.props.index + 4, "disabled", "registrars")}
              disabled={!isOGC || this.canCalculateProportion(this.props.index + 4, "disabled")}
            />
          </td>
          <td>
            <TextInput
              id={`${this.props.index}:proportion:group_a:judges`}
              name={`${this.props.index}:proportion:group_a:judges`}
              labelText=""
              onChange={this.props.onProportionChange}
              onFocus={this.props.onProportionFocus}
              onBlur={this.props.onProportionBlur}
              value={this.getProportionValue(this.props.index, "group_a", "judges")}
              disabled={!isOGC || this.canCalculateProportion(this.props.index, "group_a")}
            />
          </td>
          <td>
            <TextInput
              id={`${this.props.index}:proportion:group_a:registrars`}
              name={`${this.props.index}:proportion:group_a:registrars`}
              labelText=""
              onChange={this.props.onProportionChange}
              onFocus={this.props.onProportionFocus}
              onBlur={this.props.onProportionBlur}
              value={this.getProportionValue(this.props.index + 4, "group_a", "registrars")}
              disabled={!isOGC || this.canCalculateProportion(this.props.index + 4, "group_a")}
            />
          </td>
          <td>
            <TextInput
              id={`${this.props.index}:proportion:group_b:judges`}
              name={`${this.props.index}:proportion:group_b:judges`}
              labelText=""
              onChange={this.props.onProportionChange}
              onFocus={this.props.onProportionFocus}
              onBlur={this.props.onProportionBlur}
              value={this.getProportionValue(this.props.index, "group_b", "judges")}
              disabled={!isOGC || this.canCalculateProportion(this.props.index, "group_b")}
            />
          </td>
          <td>
            <TextInput
              id={`${this.props.index}:proportion:group_b:registrars`}
              name={`${this.props.index}:proportion:group_b:registrars`}
              labelText=""
              onChange={this.props.onProportionChange}
              onFocus={this.props.onProportionFocus}
              onBlur={this.props.onProportionBlur}
              value={this.getProportionValue(this.props.index + 4, "group_b", "registrars")}
              disabled={!isOGC || this.canCalculateProportion(this.props.index + 4, "group_b")}
            />
          </td>
          <td>
            <TextInput
              id={`${this.props.index}:proportion:group_c:judges`}
              name={`${this.props.index}:proportion:group_c:judges`}
              labelText=""
              onChange={this.props.onProportionChange}
              onFocus={this.props.onProportionFocus}
              onBlur={this.props.onProportionBlur}
              value={this.getProportionValue(this.props.index, "group_c", "judges")}
              disabled={!isOGC || this.canCalculateProportion(this.props.index, "group_c")}
            />
          </td>
          <td>
            <TextInput
              id={`${this.props.index}:proportion:group_c:registrars`}
              name={`${this.props.index}:proportion:group_c:registrars`}
              labelText=""
              onChange={this.props.onProportionChange}
              onFocus={this.props.onProportionFocus}
              onBlur={this.props.onProportionBlur}
              value={this.getProportionValue(this.props.index + 4, "group_c", "registrars")}
              disabled={!isOGC || this.canCalculateProportion(this.props.index + 4, "group_c")}
            />
          </td>
        </tr>
      </React.Fragment>
    );
  }
}


class ProportionsTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: props.data,
      error: props.error,
      editingFields: {},
      focusedFields: {}
    };

    this.updateProportionsField = this.updateProportionsField.bind(this);
    this.goToMetadata = this.goToMetadata.bind(this);
    this.handleProportionChange = this.handleProportionChange.bind(this);
    this.handleProportionFocus = this.handleProportionFocus.bind(this);
    this.handleProportionBlur = this.handleProportionBlur.bind(this);
  }

  updateProportionsField(index, name, value) {
    let { dispatch } = this.props;
    dispatch(sdg1671cActions.updateProportionsField(index, name, value));
  }

  // ─── Manual-entry handlers (OGC admin only) ───────────────────────────────

  handleProportionChange(e) {
    const isOGC = this.props.user && this.props.user.user_type === "OGC";
    if (isOGC) {
      this.setState({
        editingFields: {
          ...this.state.editingFields,
          [e.target.name]: e.target.value
        }
      });
    }
  }

  handleProportionFocus(e) {
    const isOGC = this.props.user && this.props.user.user_type === "OGC";
    if (isOGC) {
      const nameParts = e.target.name.split(":");
      const baseIndex = parseInt(nameParts[0]);
      const type = nameParts[3]; // "judges" or "registrars"
      let fieldName = nameParts[2];
      if (fieldName === "young") {
        fieldName = "age_under_44";
      }
      const actualIndex = type === "registrars" ? baseIndex + 4 : baseIndex;

      const storedValue =
        this.props.data &&
        this.props.data.proportions &&
        this.props.data.proportions[actualIndex]
          ? this.props.data.proportions[actualIndex][fieldName]
          : null;

      this.setState({
        focusedFields: {
          ...this.state.focusedFields,
          [e.target.name]: true
        },
        editingFields: {
          ...this.state.editingFields,
          [e.target.name]:
            storedValue === null || storedValue === undefined || storedValue === 0
              ? ""
              : String(storedValue)
        }
      });
    }
  }

  handleProportionBlur(e) {
    const isOGC = this.props.user && this.props.user.user_type === "OGC";
    if (isOGC) {
      const nameParts = e.target.name.split(":");
      const baseIndex = parseInt(nameParts[0]);
      const type = nameParts[3]; // "judges" or "registrars"
      let fieldName = nameParts[2];
      if (fieldName === "young") {
        fieldName = "age_under_44";
      }
      const actualIndex = type === "registrars" ? baseIndex + 4 : baseIndex;

      const inputValue = e.target.value.trim();
      let value;
      if (inputValue === "" || inputValue === "0" || inputValue === "0.00" || inputValue === "0.0") {
        value = null;
      } else {
        const parsed = parseFloat(inputValue);
        value = isNaN(parsed) ? null : parsed;
      }

      let { dispatch } = this.props;
      dispatch(sdg1671cActions.updateProportionsField(actualIndex, fieldName, value));

      const newEditingFields = { ...this.state.editingFields };
      const newFocusedFields = { ...this.state.focusedFields };
      delete newEditingFields[e.target.name];
      delete newFocusedFields[e.target.name];
      this.setState({ editingFields: newEditingFields, focusedFields: newFocusedFields });
    }
  }

  goToMetadata() {
    this.props.onPrevious();
  }

  render() {
    return (
      <React.Fragment>
        <div className="box-body">
          <div className="col-sm-8">
            <h4>Step 2: Proportional representation of various demographic groups among judges and registrars</h4>
          </div>
          <div className="row">
            <div className="col-sm-12 adaptive-table">
              <fieldset
                disabled={this.props.data && (!this.props.data.id || this.props.data.id === null)}
              >
                <table className="table table-bordered table-1671b">
                  <thead style={{fontSize: "0.95vw"}}>
                    <tr>
                      <th rowSpan="2" style={{width: "18%"}}></th>
                      <th colSpan="2" style={{background: "#A9D08E"}}>Proportion of female judges and registrars</th>
                      <th colSpan="2" style={{background: "#A9D08E"}}>Proportion of 'young' judges and registrars aged 44 and below</th>
                      <th colSpan="2" style={{background: "#A9D08E"}}>Proportion of judges and registrars with a disability</th>
                      <th colSpan="2" style={{background: "#A9D08E"}}>Proportion of judges and registrars in population group(s) A</th>
                      <th colSpan="2" style={{background: "#A9D08E"}}>Proportion of judges and registrars in population group(s) B</th>
                      <th colSpan="2" style={{background: "#A9D08E"}}>Proportion of judges and registrars in population group(s) C</th>
                    </tr>
                    <tr>
                      <th style={{background: "#A9D08E"}}>Judges</th>
                      <th style={{background: "#A9D08E"}}>Registrars</th>
                      <th style={{background: "#A9D08E"}}>Judges</th>
                      <th style={{background: "#A9D08E"}}>Registrars</th>
                      <th style={{background: "#A9D08E"}}>Judges</th>
                      <th style={{background: "#A9D08E"}}>Registrars</th>
                      <th style={{background: "#A9D08E"}}>Judges</th>
                      <th style={{background: "#A9D08E"}}>Registrars</th>
                      <th style={{background: "#A9D08E"}}>Judges</th>
                      <th style={{background: "#A9D08E"}}>Registrars</th>
                      <th style={{background: "#A9D08E"}}>Judges</th>
                      <th style={{background: "#A9D08E"}}>Registrars</th>
                    </tr>
                  </thead>
                  <tbody style={{fontSize: "0.95vw"}}>
                    <RowRenderer
                      index={2}
                      data={this.props.data}
                      title={"Constitutional / supreme courts"}
                      updateProportionsField={this.updateProportionsField}
                      user={this.props.user}
                      editingFields={this.state.editingFields}
                      onProportionChange={this.handleProportionChange}
                      onProportionFocus={this.handleProportionFocus}
                      onProportionBlur={this.handleProportionBlur}
                    />
                    <RowRenderer
                      title={"Higher-level courts"}
                      index={0}
                      data={this.props.data}
                      updateProportionsField={this.updateProportionsField}
                      user={this.props.user}
                      editingFields={this.state.editingFields}
                      onProportionChange={this.handleProportionChange}
                      onProportionFocus={this.handleProportionFocus}
                      onProportionBlur={this.handleProportionBlur}
                    />
                    <RowRenderer
                      title={"Lower-level courts"}
                      index={1}
                      data={this.props.data}
                      updateProportionsField={this.updateProportionsField}
                      user={this.props.user}
                      editingFields={this.state.editingFields}
                      onProportionChange={this.handleProportionChange}
                      onProportionFocus={this.handleProportionFocus}
                      onProportionBlur={this.handleProportionBlur}
                    />
                    <RowRenderer
                      title={"Total (across all levels of courts)"}
                      index={3}
                      data={this.props.data}
                      updateProportionsField={this.updateProportionsField}
                      user={this.props.user}
                      editingFields={this.state.editingFields}
                      onProportionChange={this.handleProportionChange}
                      onProportionFocus={this.handleProportionFocus}
                      onProportionBlur={this.handleProportionBlur}
                    />
                  </tbody>
                </table>
              </fieldset>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { data } = state.sdg1671cState;
  const { user } = state.authentication;

  return {
    data,
    user
  };
}

const connectedIndicatorData = connect(mapStateToProps)(ProportionsTable);

export { connectedIndicatorData as ProportionsTable };
